import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../../firebase/config'; // Asegúrate que la ruta sea correcta
import { signOut } from 'firebase/auth';
import { appConfig } from '../../config/appConfig';
import './NavBar.css'; // Asegúrate que la ruta sea correcta

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Cerrar el menú cuando cambia la ruta
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Manejar cambios en el tamaño de la pantalla
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Detectar si el usuario está autenticado
  const isAuthenticated = auth.currentUser;

  // Clase activa para elementos de navegación
  const getNavLinkClass = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/dashboard">
            <span>{appConfig.appName}</span>
          </Link>
        </div>

        <div className={`hamburger-menu ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          {isAuthenticated ? (
            <>
              <Link
                to="/dashboard"
                className={getNavLinkClass('/dashboard')}
                onClick={closeMenu}
              >
                <i className="fas fa-home"></i> Inicio
              </Link>
             
              {/* ---> Verifica que este enlace exista y sea correcto <--- */}
              <Link
                to="/reservar"
                className={getNavLinkClass('/reservar')}
                onClick={closeMenu}
              >
                <i className="fas fa-taxi"></i> Reservar Viaje
              </Link>
              <Link
                to="/agregar-usuario"
                className={getNavLinkClass('/agregar-usuario')}
                onClick={closeMenu}
              >
                <i className="fas fa-user-plus"></i> Agregar Usuario
              </Link>
              {/* ---> Fin de la verificación <--- */}
              <Link
                to="/reservas"
                className={getNavLinkClass('/reservas')}
                onClick={closeMenu}
              >
                <i className="fas fa-clipboard-list"></i> Reservas
              </Link>
              <Link
                to="/historial"
                className={getNavLinkClass('/historial')}
                onClick={closeMenu}
              >
                <i className="fas fa-history"></i> Historial de Viajes
              </Link>
              <Link
                to="/perfil"
                className={getNavLinkClass('/perfil')}
                onClick={closeMenu}
              >
                <i className="fas fa-user"></i> Perfil
              </Link>
              <button className="logout-btn" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt"></i> Cerrar sesión
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className={getNavLinkClass('/login')}
                onClick={closeMenu}
              >
                <i className="fas fa-sign-in-alt"></i> Iniciar sesión
              </Link>
              <Link
                to="/register"
                className={getNavLinkClass('/register')}
                onClick={closeMenu}
              >
                <i className="fas fa-user-plus"></i> Registrarse
              </Link>
            </>
          )}
        </div>

        {/* Overlay para cerrar el menú en móvil */}
        {menuOpen && <div className="navbar-overlay" onClick={closeMenu}></div>}
      </div>
    </nav>
  );
}

export default NavBar;
